import { render, staticRenderFns } from "./06-privacy.vue?vue&type=template&id=991d5562&scoped=true&"
import script from "./06-privacy.vue?vue&type=script&lang=js&"
export * from "./06-privacy.vue?vue&type=script&lang=js&"
import style0 from "./06-privacy.vue?vue&type=style&index=0&id=991d5562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991d5562",
  null
  
)

export default component.exports